export default __webpack_public_path__ + "static/media/socket.b9349d24.png";